import { AbittiExamStatistics } from './AbittiExamStatistics'

export const Statistics = () => {
  return (
    <div>
      <AbittiExamStatistics />
    </div>
  )
}
